import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import AnyQuestion from "@/pages/faqs/FaqComponents/AnyQuestion";
import { useTranslation } from "@i18n";
var PriceOfferRejectedPage = function PriceOfferRejectedPage() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8 pt-10 md:pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/rejected-offer.svg",
    width: 95,
    height: 82,
    alt: "warning paper",
    className: "mx-auto"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-center text-2xl font-bold leading-8"
  }, tShort("price_offer/rejected_offer_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-base text-[#6C7A8D] font-regular text-center leading-7"
  }, tShort("price_offer/rejected_offer_description", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "px-6 md:flex md:justify-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-primary font-bold text-white border-none outline-none hover:bg-primary-120 transition-colors duration-200 ease-in w-full p-3 rounded text-base cursor-pointer md:max-w-[315px]",
    onClick: function onClick() {
      return navigateTo("/");
    }
  }, tShort("price_offer/rejected_offer_button", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mt-[72px] md:mt-8 md:max-w-[360px] md:mx-auto en:md:max-w-[400px]"
  }, /*#__PURE__*/React.createElement(AnyQuestion, null)));
};
export default PriceOfferRejectedPage;